import { cn } from '@/shared/helpers/classnames'

import { type FC } from 'react'

import type { DialogActionsProps } from './types'
import { useDialogContext } from './useDialogContext'

/**
 * Dialog Actions component (button container)
 * Not displayed if only DialogCancelAction is present
 */
export const DialogActions: FC<DialogActionsProps> = ({ children, gap = 'md' }) => {
  const { hasOnlyCancelAction } = useDialogContext()

  // Do not display actions footer if only CancelAction is present
  if (hasOnlyCancelAction) {
    return null
  }

  return (
    <div
      className={cn('dialog-actions', {
        'dialog-actions-gap-sm': gap === 'sm',
        'dialog-actions-gap-md': gap === 'md',
        'dialog-actions-gap-lg': gap === 'lg',
      })}
    >
      {children}
    </div>
  )
}

DialogActions.displayName = 'DialogActions'
